import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = `${config.backendUrl}/managerProjectRequested`;

export const replaceProjectFinanceNotes = createAsyncThunk(
  "projectFinanceNotes/replace",
  async ({ id, ProjectFinanceNotes }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${BackendURL}/${id}/finance-notes`,
        { ProjectFinanceNotes }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to replace finance notes"
      );
    }
  }
);

const projectFinanceNotesSlice = createSlice({
  name: "projectFinanceNotes",
  initialState: {
    loading: false,
    error: null,
    success: false,
    updatedProject: null,
  },
  reducers: {
    resetFinanceNotesState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.updatedProject = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(replaceProjectFinanceNotes.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(replaceProjectFinanceNotes.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.updatedProject = action.payload.data; // controller returns {success, message, data}
      })
      .addCase(replaceProjectFinanceNotes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetFinanceNotesState } = projectFinanceNotesSlice.actions;

export default projectFinanceNotesSlice.reducer;
